import React from 'react'
import { render } from 'react-dom'


/*global $*/
$(document).ready(()=>{
  window.$ = window.jQuery = $
/*
-import { h, render } from 'preact'
*/

const A1 = require('./anim1').default
const A2 = require('./anim2').default
const A3 = require('./anim3').default
const A4 = require('./anim4').default


const anim1 = document.getElementById('anim1')
render(<A1 />, anim1)

const anim2 = document.getElementById('anim2')
render(<A2 />, anim2)

const anim3 = document.getElementById('anim3')
render(<A3 />, anim3)

render(<A4 interactive />, document.getElementById('anim-interactive'))
render(<A4 highlight />, document.getElementById('anim-director'))

})



// WEBPACK FOOTER //
// ./src/index.js